import { domains } from 'config/env'

// Convert a value to boolean, handling string representations of boolean values
function toBooleanValue(value) {
  // If already a boolean, return as-is
  if (typeof value === 'boolean') {
    return value
  }

  // If string, check if lowercase equals 'true'
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true'
  }

  // For other types, use JavaScript's truthiness evaluation
  return Boolean(value)
}

export const AUSTRALIAN_LOCALE = 'en-AU'
export const ENGLISH_LOCALE = 'en-US'
export const SPANISH_LOCALE = 'es-US'

export const DEFAULT_CONTENTFUL_URL = domains.CONTENTFUL_FUNC_APP
export const DEFAULT_INCLUDE = 3
export const DEFAULT_LOCALE = ENGLISH_LOCALE
export const DEFAULT_FORMAT = true
// Convert string 'true'/'false' to boolean, defaulting to true if not set
export const DEFAULT_PREVIEW = process.env.CONTENTFUL_PREVIEW
  ? toBooleanValue(process.env.CONTENTFUL_PREVIEW)
  : true
